import "../components/receipt/receipt.css";
import { useEffect, useRef } from "react";
import Receipt from "../components/receipt/Receipt";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { resetCart } from "../redux/cart";
import useReceipt from "../utils/useReceipt";
import { useNavigate } from "react-router-dom";
const ReceiptPrinting = () => {
  const store = useSelector((state) => state.store.Store);
  const dispatch = useDispatch();
  const id = new URLSearchParams(window.location.search).get("id");
  // console.log(id);
  const navigate = useNavigate();

  const { cart, tendered, payment_method, purchaser } = useSelector(
    (state) => state.cart,
  );
  const { allReceipt } = useReceipt();
  const receipt_id = id || Number(allReceipt[allReceipt.length - 1].id);
  const receiptRef = useRef();
  const hasPrinted = useRef(false);
  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    contentRef: receiptRef,
    onAfterPrint: () => dispatch(resetCart()),
  });
  useEffect(() => {
    if (!hasPrinted.current) {
      hasPrinted.current = true;
      handlePrint();
    }
  }, [handlePrint]);

  return (
    <div className="print-receipt-container">
      <button
        className="back-to-dashboard"
        onClick={() => {
          dispatch(resetCart());
          navigate("/", { replace: true });
        }}
      >
        back to dashboard
      </button>
      {/* payment_method === "Credit" && */}
      {
        <button
          onClick={() => {
            dispatch(resetCart());
            navigate(`/credit?id=${receipt_id}`, { replace: true });
          }}
          className="add-to-credit"
        >
          Add to credit
        </button>
      }
      <Receipt
        store={store}
        items={cart}
        ref={receiptRef}
        tendered={tendered}
        payment_method={payment_method}
        purchaser={purchaser}
        receipt_id={receipt_id}
      />
      ;
    </div>
  );
};

export default ReceiptPrinting;
